function limpiarCadenaBase64(valor) {
  if (typeof valor !== 'string') return ''
  return valor.trim().replace(/\s+/g, '')
}

function obtenerExtensionDesdeMime(mimeType) {
  switch (mimeType) {
    case 'image/jpeg':
      return 'jpg'
    case 'image/svg+xml':
      return 'svg'
    default:
      return (mimeType.split('/')[1] || 'png').toLowerCase()
  }
}

export function esBase64Imagen(valor) {
  if (typeof valor !== 'string') return false

  const limpio = limpiarCadenaBase64(valor)
  if (!limpio || limpio.length < 40) return false

  const match = limpio.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.+)$/)
  if (!match) return false

  return /^[A-Za-z0-9+/=]+$/.test(match[2])
}

export function normalizarBase64Imagen(valor) {
  if (!esBase64Imagen(valor)) return null

  const limpio = limpiarCadenaBase64(valor)
  const dataUrlMatch = limpio.match(/^data:(image\/[a-zA-Z0-9.+-]+);base64,(.+)$/)
  if (!dataUrlMatch) return null

  const mimeType = dataUrlMatch[1]
  const contenido = dataUrlMatch[2]
  return {
    mimeType,
    extension: obtenerExtensionDesdeMime(mimeType),
    contenido,
  }
}
